export interface ParametresMois {
    type: TypeEnum
    positionDansLeMois?: number;
}

export enum TypeEnum {
  DayOfMonth = "day_of_month",
  DayPosition = "day_position",
}
